<div class="flex flex-col h-full overflow-y-auto">
    <div class="flex-1 p-2">
        <ng-container>
            <form [formGroup]="notificationsForm">
                <!-- Canais de Notificação -->
                <div class="w-full py-4">
                    <div class="flex w-full">
                        <div class="p-2 rounded-xl bg-blue-100 ml-2 h-[40px]">
                            <mat-icon svgIcon="mat_solid:notifications" class="icon-size-6 text-blue-600"></mat-icon>
                        </div>
                        <div class="px-3">
                            <div class="w-full leading-10">
                                <span class="text-[17px] font-[500] font-remote">Canais de Notificação</span>
                            </div>
                        </div>
                    </div>
                    <div class="w-full p-4 h-full">
                        <!-- Notificações por Email -->
                        <div class="py-4 flex items-center justify-between opacity-50 cursor-not-allowed">
                            <mat-icon class="w-[36px] h-[36px] pb-[10px]" [svgIcon]="'mat_solid:email'"></mat-icon>
                            <div class="flex-auto ml-2 pr-2">
                                <div class="leading-6">
                                    <span class="text-[15px] font-inter font-[500] text-gray-600">Notificações por Email</span>
                                </div>
                                <div>
                                    <span class="text-[14px] font-inter font-[400] text-gray-500">Receba notificações no seu email</span>
                                </div>
                            </div>
                            <mat-slide-toggle class="ml-2 cursor-not-allowed" [formControlName]="'emailNotifications'" [color]="'primary'" [disabled]="true">
                            </mat-slide-toggle>
                        </div>

                        <!-- Notificações Push -->
                        <div class="py-4 flex items-center justify-between opacity-50 cursor-not-allowed">
                            <mat-icon class="w-[36px] h-[36px] pb-[10px]" [svgIcon]="'mat_solid:notifications_active'"></mat-icon>
                            <div class="flex-auto ml-2 pr-2">
                                <div class="leading-6">
                                    <span class="text-[15px] font-inter font-[500] text-gray-600">Notificações Push</span>
                                </div>
                                <div>
                                    <span class="text-[14px] font-inter font-[400] text-gray-500">Receba notificações no navegador</span>
                                </div>
                            </div>
                            <mat-slide-toggle class="ml-2 cursor-not-allowed" [formControlName]="'pushNotifications'" [color]="'primary'" [disabled]="true">
                            </mat-slide-toggle>
                        </div>
                    </div>
                </div>

                <!-- Eventos e Atividades -->
                <div class="w-full py-4">
                    <div class="flex w-full">
                        <div class="p-2 rounded-xl bg-purple-100 ml-2 h-[40px]">
                            <mat-icon svgIcon="mat_solid:event" class="icon-size-6 text-purple-600"></mat-icon>
                        </div>
                        <div class="px-3">
                            <div class="w-full leading-10">
                                <span class="text-[17px] font-[500] font-remote">Eventos e Atividades</span>
                            </div>
                        </div>
                    </div>
                    <div class="w-full p-4 h-full">
                        <!-- Eventos da Igreja -->
                        <div class="py-4 flex items-center justify-between opacity-50 cursor-not-allowed">
                            <mat-icon class="w-[36px] h-[36px] pb-[10px]" [svgIcon]="'mat_solid:home_work'"></mat-icon>
                            <div class="flex-auto ml-2 pr-2">
                                <div class="leading-6">
                                    <span class="text-[15px] font-inter font-[500] text-gray-600">Eventos da Igreja</span>
                                </div>
                                <div>
                                    <span class="text-[14px] font-inter font-[400] text-gray-500">Novos eventos e atualizações</span>
                                </div>
                            </div>
                            <mat-slide-toggle class="ml-2 cursor-not-allowed" [formControlName]="'churchEventsNotifications'" [color]="'primary'" [disabled]="true">
                            </mat-slide-toggle>
                        </div>

                        <!-- Eventos do Calendário -->
                        <div class="py-4 flex items-center justify-between opacity-50 cursor-not-allowed">
                            <mat-icon class="w-[36px] h-[36px] pb-[10px]" [svgIcon]="'mat_solid:calendar_today'"></mat-icon>
                            <div class="flex-auto ml-2 pr-2">
                                <div class="leading-6">
                                    <span class="text-[15px] font-inter font-[500] text-gray-600">Eventos do Calendário</span>
                                </div>
                                <div>
                                    <span class="text-[14px] font-inter font-[400] text-gray-500">Lembretes de eventos agendados</span>
                                </div>
                            </div>
                            <mat-slide-toggle class="ml-2 cursor-not-allowed" [formControlName]="'calendarEventsNotifications'" [color]="'primary'" [disabled]="true">
                            </mat-slide-toggle>
                        </div>

                        <!-- Aniversários -->
                        <div class="py-4 flex items-center justify-between opacity-50 cursor-not-allowed">
                            <mat-icon class="w-[36px] h-[36px] pb-[10px]" [svgIcon]="'mat_solid:cake'"></mat-icon>
                            <div class="flex-auto ml-2 pr-2">
                                <div class="leading-6">
                                    <span class="text-[15px] font-inter font-[500] text-gray-600">Aniversários</span>
                                </div>
                                <div>
                                    <span class="text-[14px] font-inter font-[400] text-gray-500">Aniversários de membros</span>
                                </div>
                            </div>
                            <mat-slide-toggle class="ml-2 cursor-not-allowed" [formControlName]="'birthdaysNotifications'" [color]="'primary'" [disabled]="true">
                            </mat-slide-toggle>
                        </div>
                    </div>
                </div>

                <!-- Financeiro e Membros -->
                <div class="w-full py-4">
                    <div class="flex w-full">
                        <div class="p-2 rounded-xl bg-green-100 ml-2 h-[40px]">
                            <mat-icon svgIcon="mat_solid:attach_money" class="icon-size-6 text-green-600"></mat-icon>
                        </div>
                        <div class="px-3">
                            <div class="w-full leading-10">
                                <span class="text-[17px] font-[500] font-remote">Financeiro e Membros</span>
                            </div>
                        </div>
                    </div>
                    <div class="w-full p-4 h-full">
                        <!-- Transações Financeiras -->
                        <div class="py-4 flex items-center justify-between opacity-50 cursor-not-allowed">
                            <mat-icon class="w-[36px] h-[36px] pb-[10px]" [svgIcon]="'mat_solid:account_balance_wallet'"></mat-icon>
                            <div class="flex-auto ml-2 pr-2">
                                <div class="leading-6">
                                    <span class="text-[15px] font-inter font-[500] text-gray-600">Transações Financeiras</span>
                                </div>
                                <div>
                                    <span class="text-[14px] font-inter font-[400] text-gray-500">Movimentações e atualizações financeiras</span>
                                </div>
                            </div>
                            <mat-slide-toggle class="ml-2 cursor-not-allowed" [formControlName]="'financialTransactionsNotifications'" [color]="'primary'" [disabled]="true">
                            </mat-slide-toggle>
                        </div>

                        <!-- Novos Membros -->
                        <div class="py-4 flex items-center justify-between opacity-50 cursor-not-allowed">
                            <mat-icon class="w-[36px] h-[36px] pb-[10px]" [svgIcon]="'mat_solid:person_add'"></mat-icon>
                            <div class="flex-auto ml-2 pr-2">
                                <div class="leading-6">
                                    <span class="text-[15px] font-inter font-[500] text-gray-600">Novos Membros</span>
                                </div>
                                <div>
                                    <span class="text-[14px] font-inter font-[400] text-gray-500">Quando novos membros são adicionados</span>
                                </div>
                            </div>
                            <mat-slide-toggle class="ml-2 cursor-not-allowed" [formControlName]="'newMembersNotifications'" [color]="'primary'" [disabled]="true">
                            </mat-slide-toggle>
                        </div>
                    </div>
                </div>

                <!-- Resumos -->
                <div class="w-full py-4">
                    <div class="flex w-full">
                        <div class="p-2 rounded-xl bg-orange-100 ml-2 h-[40px]">
                            <mat-icon svgIcon="mat_solid:summarize" class="icon-size-6 text-orange-600"></mat-icon>
                        </div>
                        <div class="px-3">
                            <div class="w-full leading-10">
                                <span class="text-[17px] font-[500] font-remote">Resumos</span>
                            </div>
                        </div>
                    </div>
                    <div class="w-full p-4 h-full">
                        <!-- Resumo Semanal -->
                        <div class="py-4 flex items-center justify-between opacity-50 cursor-not-allowed">
                            <mat-icon class="w-[36px] h-[36px] pb-[10px]" [svgIcon]="'mat_solid:date_range'"></mat-icon>
                            <div class="flex-auto ml-2 pr-2">
                                <div class="leading-6">
                                    <span class="text-[15px] font-inter font-[500] text-gray-600">Resumo Semanal</span>
                                </div>
                                <div>
                                    <span class="text-[14px] font-inter font-[400] text-gray-500">Receba um resumo semanal das atividades</span>
                                </div>
                            </div>
                            <mat-slide-toggle class="ml-2 cursor-not-allowed" [formControlName]="'weeklyDigest'" [color]="'primary'" [disabled]="true">
                            </mat-slide-toggle>
                        </div>
                    </div>
                </div>
            </form>
        </ng-container>
    </div>
</div>
